import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$2 } from './button-base2.js';
import { d as defineCustomElement$1 } from './nl-select2.js';

import { baseCss } from './css.js';
const nlOtpMigrateCss = baseCss;

const NlOtpMigrateStyle0 = nlOtpMigrateCss;

const NlImportFlow = /*@__PURE__*/ proxyCustomElement(class NlImportFlow extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlImportAccount = createEvent(this, "nlImportAccount", 7);
        this.titleInfo = 'Import keys to storage service';
        this.titleImport = 'Choose a service';
        this.textImport = 'You will be prompted to import keys to the chosen service, and this website will connect to your keys.';
        this.services = [];
    }
    handleDomainSelect(event) {
        const s = this.services.find(s => s.domain === event.detail);
        state.nlImport = s;
    }
    handleCreateAccount(e) {
        e.preventDefault();
        this.nlImportAccount.emit(state.nlImport);
    }
    render() {
        const options = this.services.filter(s => s.canImport).map(s => ({ name: s.domain, value: s.domain }));
        return (h(Fragment, { key: '8295d7fd819696a264100c3c1834a7e943f3f60e' }, h("div", { key: '4d0e48726fccfe24be45db8ef328b25b4778763c', class: "p-4 overflow-y-auto" }, h("h1", { key: '8a035ea913fa770188e62557971649a223fe7ed8', class: "nl-title font-bold text-center text-2xl" }, this.titleImport), h("p", { key: 'ad9c8565205acafeea8ab3991cc405ae84a6c95a', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.textImport)), h("div", { key: '7ee07d8ac0fc0278f342e794686126465b643278', class: "max-w-72 mx-auto mb-5" }, h("div", { key: '677ca636b72bcefc6092e2e09b8c0ad445a956f6', class: "mb-0.5" }, h("nl-select", { key: '8ec042faaa8319c0d683818cfa5321c20b2e6a57', onSelectDomain: e => this.handleDomainSelect(e), selected: 0, options: options })), h("p", { key: 'd6348d95a65a003047e0961a9b8b86835bcebf1f', class: "nl-title font-light text-sm mb-2" }, "Default provider is a fine choice to start with."), h("div", { key: 'df09b9b23fd192407f797d8b191a30ca3a649142', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '77901d809985d421f9be1e7ff6e5263db52aa37f', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: '87eb6648d8d5e4e4990f745c507bcaacddc6676a', disabled: state.isLoading, onClick: e => this.handleCreateAccount(e), titleBtn: "Start importing" }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { slot: "icon-start", style: { display: 'none' }, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" })))))));
    }
    static get style() { return NlOtpMigrateStyle0; }
}, [0, "nl-otp-migrate", {
        "titleInfo": [1025, "title-info"],
        "titleImport": [1, "title-import"],
        "textImport": [1, "text-import"],
        "services": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-otp-migrate", "button-base", "nl-select"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-otp-migrate":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlImportFlow);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "nl-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlImportFlow as N, defineCustomElement as d };

//# sourceMappingURL=nl-otp-migrate2.js.map